import { render, staticRenderFns } from "./Upgrade.vue?vue&type=template&id=ee1f0064&scoped=true"
import script from "./Upgrade.vue?vue&type=script&lang=js"
export * from "./Upgrade.vue?vue&type=script&lang=js"
import style0 from "./Upgrade.vue?vue&type=style&index=0&id=ee1f0064&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee1f0064",
  null
  
)

export default component.exports